import React from "react";
import Icon from "@ant-design/icons";

const DocumentSvg = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="none"
        viewBox="0 0 20 20"
    >
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M11.667 1.917V5.5c0 .467 0 .7.09.878.08.156.208.284.365.365.178.09.411.09.878.09h3.583m.084 3.084V13.5c0 1.4 0 2.1-.272 2.635a2.5 2.5 0 0 1-1.093 1.093c-.535.272-1.235.272-2.635.272H7.333c-1.4 0-2.1 0-2.635-.272a2.5 2.5 0 0 1-1.093-1.093c-.272-.535-.272-1.235-.272-2.635V6.5c0-1.4 0-2.1.272-2.635a2.5 2.5 0 0 1 1.093-1.093c.535-.272 1.235-.272 2.635-.272h3.917c.612 0 .918 0 1.204.069.254.061.497.163.72.3.252.155.469.372.902.807l2.5 2.5c.435.434.652.65.808.902.136.223.238.466.3.72.068.286.068.592.068 1.204Z"
        ></path>
    </svg>
);

const DocumentIcon = (props) => <Icon component={DocumentSvg} {...props} />;

export { DocumentIcon };